import { createRef, PureComponent } from 'react';
import type { ReactNode, RefObject, TransitionEvent } from 'react';
import { TruncatorWrapper } from './styled';

export interface Props {
  open: boolean;
  children: ReactNode;
  minHeight: number;
  animationDuration?: number;
  showGradient?: boolean;
}

interface State {
  open: boolean;
  autoHeight: boolean;
}

class DeprecatedTruncator extends PureComponent<Props, State> {
  private ref: RefObject<HTMLDivElement>;

  state = {
    open: this.props.open,
    autoHeight: false,
  };

  constructor(props) {
    super(props);
    this.ref = createRef<HTMLDivElement>();
  }

  componentDidUpdate(prevProps) {
    const { open: nextOpen } = this.props;
    const { open: prevOpen } = prevProps;
    if (nextOpen !== prevOpen) {
      if (nextOpen) {
        this.setState({
          open: nextOpen,
        });
      } else if (!nextOpen) {
        this.setState(
          {
            autoHeight: false,
          },
          () =>
            this.setState({
              open: nextOpen,
            })
        );
      }
    }
  }

  handleTransitionEnd = (e: TransitionEvent) => {
    const { open } = this.props;
    if (e.propertyName === 'height' && e.pseudoElement !== '::after' && open) {
      this.setState({
        autoHeight: true,
      });
    }
  };

  render() {
    const { ref, handleTransitionEnd } = this;
    const { open, autoHeight } = this.state;
    const { children, minHeight, animationDuration, showGradient } = this.props;
    return (
      <TruncatorWrapper
        open={open}
        setToAutoHeight={autoHeight}
        minHeight={minHeight}
        maxHeight={ref.current ? ref.current.offsetHeight : minHeight}
        animationDuration={animationDuration}
        onTransitionEnd={handleTransitionEnd}
        showGradient={showGradient === undefined ? true : showGradient}
      >
        <div ref={ref}>{children}</div>
      </TruncatorWrapper>
    );
  }
}

export default DeprecatedTruncator;
